import styles from "./imageCard.module.scss";
import { createMarkup, goToUrl,componentResize } from "../../../utils/helperServices";
import { useRouter } from "../../atoms/DependencyHelper";
import PropTypes from "prop-types";
import CTAButton from "../../atoms/CTAButton/CTAButton";
import * as Analytics from "../../../services/analyticsUtag";

const ImageCard = ({ image, type, icon, title, description, ctaLabel, ctaLink, ctaVariant, id, dataCMSTitle, analyticsData = {},isOpenNewTab }) => {
	const router = useRouter();
	const handleClick = () => {
		Analytics.link(analyticsData);
	};
	const isMobile=componentResize();
	return (
		<div
			style={{
				backgroundImage: `url(${image})`
			}}
			className={`${styles["card-container"]} ${styles[type]}`}
			id={id}
			data-cms-title={dataCMSTitle.toLowerCase()}
		>
			<div className={styles["card-info"]}>
				{icon && <img src={icon} className={styles["card-icon"]} />}
				{title && <div className={styles["card-title"]}>{title}</div>}
				{description && (
					<div className={styles["card-heading"]} dangerouslySetInnerHTML={createMarkup(description)} />
				)}
				{ctaLabel && (
					<div className={styles["card-button"]}>
						<CTAButton variant={ctaVariant} id={`${id}_CTABtn`} url={ctaLink} className={`${isMobile ?"pl-s pr-s" :`pl-m pr-m`} ${styles["custom-style"]} `} handleClick={handleClick} isOpenNewTab={isOpenNewTab}>
							{ctaLabel}
						</CTAButton>
					</div>
				)}
			</div>
			<div className={styles["card-gradient"]} />
		</div>
	);
};

ImageCard.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	image: PropTypes.string,
	icon: PropTypes.any,
	ctaLink: PropTypes.string,
	ctaLabel: PropTypes.string,
	ctaVariant: PropTypes.string,
	type: PropTypes.string,
	id: PropTypes.string,
	dataCMSTitle: PropTypes.string,
	analyticsData: PropTypes.any,
};

export default ImageCard;
